export const regionPrice = {
  "Europe - Africa": {
    cohorts: ["cohort1", "cohort2"],
    payments: [
      {
        id: 30,
        price: 1400,
        slashPrice: null,
        buttonLabel: "One Time Payment",
        buttonUrl: "https://buy.stripe.com/14k6qVgdq9cv5pKdTt",
        description: [
          "➢ Product ownership training",
          "➢ Project Management Methodologies",
          "➢ Internship (Work Experience)",
          "➢ Scrum training",
          "➢ 1-on-1 Resume/CV Clinic",
          "➢ Interview Prep Session",
          "➢ Interview Prep Videos",
          "➢ SQL, Power BI and Excel course",
          "➢ Work Reference",
          "➢ Life-time access to recordings",
          "➢ Access to self-paced course",
          "➢ 1-month on-the-job support",
        ].join('\n'),
        pillText: null,
        type: "One-time payment",
        defaultPrice: 1700,
        // href: "https://buy.stripe.com/9AQ5mR5yM3Sb19u2aM",
        // href2: "https://buy.stripe.com/5kA3eJgdq74nf0k9Df",
        // href3: "https://buy.stripe.com/7-time-installment",
        defaultSlash: null,
      },
      {
        id: 31,
        price: 467,
        slashPrice: null,
        buttonLabel: "Three-time payment",
        buttonUrl: "https://buy.stripe.com/9AQ5mR5yM3Sb19u2aM",
        description: [
          "➢ Product ownership training",
          "➢ Project Management Methodologies",
          "➢ Internship (Work Experience)",
          "➢ Scrum training",
          "➢ 1-on-1 Resume/CV Clinic",
          "➢ Interview Prep Session",
          "➢ Interview Prep Videos",
          "➢ SQL, Power BI and Excel course",
          "➢ Work Reference",
          "➢ Life-time access to recordings",
          "➢ Access to self-paced course",
          "➢ 1-month on-the-job support",
        ].join('\n'),
        pillText: null,
        type: "Three-time payment ",
        defaultPrice: 567,
        // href: "https://buy.stripe.com/5kA5mR1iwcoH6tO9D0",
        // href2: "https://buy.stripe.com/6oE3eJ5yM88r6tO7uU",
        // href3: "https://buy.stripe.com/7-time-installment",
        defaultSlash: null,
      },
      {
        id: 32,
        price: 290,
        slashPrice: null,
        buttonLabel: "Five-time payment",
        buttonUrl: "https://buy.stripe.com/5kA3eJgdq74nf0k9Df",
        description: [
          "➢ Product ownership training",
          "➢ Project Management Methodologies",
          "➢ Internship (Work Experience)",
          "➢ Scrum training",
          "➢ 1-on-1 Resume/CV Clinic",
          "➢ Interview Prep Session",
          "➢ Interview Prep Videos",
          "➢ SQL, Power BI and Excel course",
          "➢ Work Reference",
          "➢ Life-time access to recordings",
          "➢ Access to self-paced course",
          "➢ 1-month on-the-job support",
        ].join('\n'),
        pillText: null,
        type: "Five-time payment",
        defaultPrice: 350,
        // href: "https://buy.stripe.com/6oE3eJ5yM88r6tO7uU",
        // href2: "https://buy.stripe.com/7-time-installment",
        // href3: "https://buy.stripe.com/7-time-installment",
        defaultSlash: null,
      },
    ],
  },
  "US & Canada": {
    cohorts: ["cohort3", "cohort4"],
    payments: [
      {
        id: 15,
        price: 1800,
        slashPrice: null ,
        buttonLabel: "One Time Payment",
        buttonUrl: "https://buy.stripe.com/14k6qVgdq9cv5pKdTt",
        description: [
          "➢ Product ownership training",
          "➢ Project Management Methodologies",
          "➢ Internship (Work Experience)",
          "➢ Scrum training",
          "➢ 1-on-1 Resume/CV Clinic",
          "➢ Interview Prep Session",
          "➢ Interview Prep Videos",
          "➢ SQL, Power BI and Excel course",
          "➢ Work Reference",
          "➢ Life-time access to recordings",
          "➢ Access to self-paced course",
          "➢ 1-month on-the-job support",
        ].join("\n"),
        pillText: "One-time payment",
        type: "One-time payment ",
        defaultPrice: 2500,
        // href: "https://buy.stripe.com/9AQ5mR5yM3Sb19u2aM",
        // href2: "https://buy.stripe.com/5kA3eJgdq74nf0k9Df",
        // href3: "https://buy.stripe.com/7-time-installment",
        defaultSlash: null,
      },
       {
        id: 40,
        price: 600,
        slashPrice: null,
        buttonLabel: "Three-time payment ",
        buttonUrl: "https://buy.stripe.com/9AQ5mR5yM3Sb19u2aM",
        description: [
          "➢ Product ownership training",
          "➢ Project Management Methodologies",
          "➢ Internship (Work Experience)",
          "➢ Scrum training",
          "➢ 1-on-1 Resume/CV Clinic",
          "➢ Interview Prep Session",
          "➢ Interview Prep Videos",
          "➢ SQL, Power BI and Excel course",
          "➢ Work Reference",
          "➢ Life-time access to recordings",
          "➢ Access to self-paced course",
          "➢ 1-month on-the-job support",
        ].join("\n"),
        pillText: null,
        type: "Three-time payment ",
        defaultPrice: 834,
        // href: "https://buy.stripe.com/5kA5mR1iwcoH6tO9D0",
        // href2: "https://buy.stripe.com/6oE3eJ5yM88r6tO7uU",
        // href3: "https://buy.stripe.com/7-time-installment",
        defaultSlash: null,
      },
      {
        id: 41,
        price: 370,
        slashPrice: null,
        buttonLabel: "Five-time payment",
        buttonUrl: "https://buy.stripe.com/5kA3eJgdq74nf0k9Df",
        description: [
          "➢ Product ownership training",
          "➢ Project Management Methodologies",
          "➢ Internship (Work Experience)",
          "➢ Scrum training",
          "➢ 1-on-1 Resume/CV Clinic",
          "➢ Interview Prep Session",
          "➢ Interview Prep Videos",
          "➢ SQL, Power BI and Excel course",
          "➢ Work Reference",
          "➢ Life-time access to recordings",
          "➢ Access to self-paced course",
          "➢ 1-month on-the-job support",
        ].join("\n"),
        pillText: null,
        type: "Five-time payment",
        defaultPrice: 520,
      },
    ],
  },
};

export const formDatas = {
  defaultRegion: "", // Change to "US & Canada" for testing other regions
};
